export const getInitialState = ({ loading, cache }) => {
  return {
    filter: {
      ...(cache && cache.filter)
    },
    search: (cache && cache.search) || "",
    limit: (cache && cache.limit) || 10,
    pageNum: (cache && cache.pageNum) || 0,
    order: (cache && cache.order) || {
      id: -1,
      name: "",
      comparator: "",
      sort: ""
    },
    pageSize: (cache && cache.limit) || 10,
    userPageCount: 0,
    Prospects: [],
    loading: loading,
    render: !loading,
    isSubscription: false,
    showDeleteConfirmation: false,
    deleteProspectIds: [],
    convertProspectIds: [],
    deleteCustomerId: null,
    showConvertToLeadConfirmation: false,
    showConvertToMarketingOnlyConfirmation: false,
    showPermanentDeletConfirmation: false,
    isPermDeleteSubmitted: null,
    showConvertDialog: false,
    convertMessage: "",
    editItemId: false,
    convertMultipleFailureData: [],
    showCsmDialog: false,
    csmId: undefined,
    disableChange: true,
    showConfirmation: false,
    selectedRowData: {}
  };
};

export default function reducer(state, action) {
  switch (action.type) {
    case "UPDATE":
      return Object.assign({}, state, { ...action.payload });

    case "RESET":
      return Object.assign({}, state, {
        ...action.payload,
        filter: {},
        search: "",
        searchTerm: "",
        limit: 10,
        pageSize: 10,
        pageNum: 0,
        order: {
          id: -1,
          name: "",
          comparator: "",
          sort: ""
        },
        userPageCount: 0
      });

    default:
      return state;
  }
}
